import { render } from "./InstallerLeads.vue?vue&type=template&id=122f13bb"
import script from "./InstallerLeads.vue?vue&type=script&lang=js"
export * from "./InstallerLeads.vue?vue&type=script&lang=js"

import exportComponent from "/Users/susana/Local Sites/rhinodoors_dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__